import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import s from './UserBlockPopup.scss';
export const UserBlockPopup = ({ user, requestClose, blockUser, blockUserAndRedirect, redirectLocation })=>{
    const { t } = useTranslation();
    const popupText = /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "moderation.blockPerson.text"
    }, "You won’t be able to chat or see each other’s deviations. If you have favourited each other’s deviations, they will be unfavourited.", /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("a", {
        href: "https://www.deviantartsupport.com/en/article/how-do-i-block-users-from-contacting-me-on-deviantart#what-does-blocking-someone-do",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "What else does blocking do?")));
    return /*#__PURE__*/ React.createElement(ConfirmationModal, {
        title: t('moderation.blockPerson', {
            username: user.username
        }),
        text: popupText,
        confirmBtnType: "danger",
        confirmBtnLabel: t('moderation.block'),
        onCancel: requestClose,
        onConfirm: ()=>{
            redirectLocation ? blockUserAndRedirect(user, redirectLocation) : blockUser(user);
            requestClose();
        },
        icon: /*#__PURE__*/ React.createElement(Warning, null),
        isOpen: true
    });
};
export default UserBlockPopup;

//# sourceMappingURL=UserBlockPopup.js.map